export default (
  state = {
    userProfile: {},
    accountsSettings: {},
    // Info section individual fields below
    companyDisplayNameInput: "",
    companyLegalNameInput: "",
    // Email section individual fields below
    companyCommunicationEmailInput: "",
    // Address section individual fields below
    companyAddressTypeInput: "",
    companyAddressStreetInput: "",
    companyAddressCityInput: "",
    companyAddressStateInput: "",
    companyAddressPinCodeInput: "",
    companyAddressCountryInput: "",
    // Teammates/Roles - RBAC Settings
    teammatesList: [],
    orgRolesList: [],
    userGroups: [],
    roleDetails: {},
    orgPermissionsList: [],
    orgPermissionsListCategorized: [],
    documentSections: [],
    // Integrations Settings
    crmConfig: {
      crm: {
        is_authenticated: false,
      },
      esign: {},
    },
    // SAML AUTH Settings
    samlSettings: {},
    // REVV OAUTH
    revvOauth: {
      apps: [],
      currentView: "list",
      fromPath: "list",
      selectedAppID: "",
      selectedClientID: "",
    },
    billingBandNotify: false,
    lastBillingInfo: false,
  },
  action,
) => {
  switch (action.type) {
    /*
    ===============================
    User Profile Settings
    ===============================
    */
    case "USER_PROFILE_SETTINGS":
      return { ...state, userProfile: action.payload };

    case "USER_PROFILE_PICTURE":
      return {
        ...state,
        userProfile: { ...state.userProfile, image_url: action.payload },
      };
    /*
    ===============================
    Accounts Settings
    ===============================
    */
    case "ACCOUNTS_SETTINGS":
      return { ...state, accountsSettings: action.payload };
    // Info section individual fields below
    case "COMPANY_DISPLAY_NAME_INPUT":
      return { ...state, companyDisplayNameInput: action.payload };
    case "COMPANY_LEGAL_NAME_INPUT":
      return { ...state, companyLegalNameInput: action.payload };
    // Email section individual fields below
    case "COMPANY_COMMUNICATION_EMAIL_INPUT":
      return { ...state, companyCommunicationEmailInput: action.payload };
    // Address section individual fields below
    case "COMPANY_ADDRESS_TYPE_INPUT":
      return { ...state, companyAddressTypeInput: action.payload };
    case "COMPANY_ADDRESS_STREET_INPUT":
      return { ...state, companyAddressStreetInput: action.payload };
    case "COMPANY_ADDRESS_CITY_INPUT":
      return { ...state, companyAddressCityInput: action.payload };
    case "COMPANY_ADDRESS_STATE_INPUT":
      return { ...state, companyAddressStateInput: action.payload };
    case "COMPANY_ADDRESS_PIN_CODE_INPUT":
      return { ...state, companyAddressPinCodeInput: action.payload };
    case "COMPANY_ADDRESS_COUNTRY_INPUT":
      return { ...state, companyAddressCountryInput: action.payload };
    /*
    ===============================
    RBAC Settings
    ===============================
    */
    case "TEAMMATES_INIT_DATA":
      return {
        ...state,
        teammatesList: action.payload[0].users,
        orgRolesList: action.payload[1].Roles,
        userGroups: action.payload[2].Usergroups,
      };
    case "CREATE_USER_GROUP":
      return {
        ...state,
        userGroups: [...state.userGroups, action.payload],
      };
    case "DELETE_USER_GROUP":
      return {
        ...state,
        teammatesList: action.payload.teammatesList,
        userGroups: action.payload.userGroups,
      };
    case "CHANGE_USER_GROUP_STATUS":
      return {
        ...state,
        teammatesList: action.payload.teammatesList,
        userGroups: action.payload.userGroups,
      };
    case "REFERRAL_LIST":
      return { ...state, teammatesList: action.payload };
    case "TEAMMATES_LIST":
      return { ...state, teammatesList: action.payload };
    case "ORG_ROLES_LIST":
      return { ...state, orgRolesList: action.payload };
    case "ROLE_DETAILS":
      return { ...state, roleDetails: action.payload };
    case "ORG_PERMISSIONS_LIST":
      return { ...state, orgPermissionsList: action.payload };
    case "ORG_PERMISSIONS_LIST_CATEGORIZED":
      return { ...state, orgPermissionsListCategorized: action.payload };
    /*
    ===============================
    Integrations Settings
    ===============================
    */
    case "CRM_INIT_DATA":
      return { ...state, crmConfig: action.payload };

    case "CRM_AUTH_SUCCESS":
      return {
        ...state,
        crmConfig: {
          crm: {
            ...state.crmConfig.crm,
            is_authenticated: action.payload.is_authenticated,
            instance_url: action.payload.instance_url,
          },
        },
      };

    /*
    ===============================
    Authentication Settings
    ===============================
    */

    case "SAML_SETTINGS_INIT_DATA":
      return { ...state, samlSettings: action.payload };

    /*
    ===============================
    Revv API Settings
    ===============================
    */

    case "TOGGLE_REVV_OAUTH_VIEW":
      return {
        ...state,
        revvOauth: {
          ...state.revvOauth,
          currentView: action.payload.view,
          fromPath: action.payload.fromPath,
          selectedAppID: action.payload.selectedAppID,
          selectedClientID: action.payload.selectedClientID,
        },
      };

    case "FETCH_REVV_OAUTH_APPS":
      return {
        ...state,
        revvOauth: {
          ...state.revvOauth,
          apps: action.payload,
        },
      };

    case "ADD_REVV_OAUTH_APPS":
      return {
        ...state,
        revvOauth: {
          ...state.revvOauth,
          apps: [...state.revvOauth.apps, action.payload],
          selectedAppID: action.payload.id,
        },
      };

    case "ADD_REVV_OAUTH_CLIENT": {
      const appsClone = JSON.parse(JSON.stringify(state.revvOauth.apps));
      appsClone.forEach(app => {
        if (app.id === action.payload.appID) {
          if (app.clients) {
            app.clients.push(action.payload.data);
          } else {
            app.clients = [action.payload.data];
          }
        }
      });
      return {
        ...state,
        revvOauth: {
          ...state.revvOauth,
          apps: appsClone,
          selectedClientID: action.payload.data.client_id,
        },
      };
    }

    case "UPDATE_REVV_OAUTH_CLIENT": {
      const updateAppData = state.revvOauth.apps.map(app => {
        if (app.id === action.payload.appID) {
          const updatedClients = app.clients.map(client => {
            if (client.client_id === action.payload.clientID) {
              client = action.payload.data;
            }
            return client;
          });
          app.clients = updatedClients;
          return app;
        }
        return app;
      });
      return {
        ...state,
        revvOauth: {
          ...state.revvOauth,
          apps: updateAppData,
          selectedAppID: action.payload.appID,
          selectedClientID: action.payload.clientID,
        },
      };
    }

    case "DELETE_REVV_OAUTH_CLIENT": {
      const updateAppData = state.revvOauth.apps.map(app => {
        if (app.id === action.payload.appID) {
          const updatedClients = app.clients.filter(
            client => client.client_id !== action.payload.clientID,
          );
          app.clients = updatedClients;
          return app;
        }
        return app;
      });
      return {
        ...state,
        revvOauth: {
          ...state.revvOauth,
          apps: updateAppData,
        },
      };
    }

    case "NUKE_REVV_OAUTH_DATA":
      return {
        ...state,
        revvOauth: {
          apps: [],
          currentView: "list",
          selectedAppID: "",
          selectedClientID: "",
        },
      };

    case "BILLING_BAND_NOTIFY_ACTION":
      return {
        ...state,
        billingBandNotify: action.payload,
      };

    case "BILLING_LAST_PAYMENT":
      return {
        ...state,
        lastBillingInfo: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/SettingsReducer.js